import { FC } from 'react'
import { useTheme } from '@emotion/react'
import ReactCodeInput from 'react-code-input'
import { inputStyle } from './styles'

interface Props {
  onCodeFill: (code: string) => void
  isValid: boolean
  inputRef?: React.Ref<ReactCodeInput>
}

export const CodeInput: FC<Props> = ({ onCodeFill, isValid, inputRef }) => {
  const theme = useTheme()

  return (
    <ReactCodeInput
      onChange={(code) => {
        if (code.length === 6) {
          onCodeFill(code)
        }
      }}
      inputMode="numeric"
      name="code"
      type="number"
      fields={6}
      inputStyle={inputStyle(isValid, theme.ERROR_1, theme.DARK_0)}
      ref={inputRef}
    />
  )
}
